/** @format */

import React, { FC, memo, Suspense } from "react";
import { getAllCardTypeIds } from "../contentEditor/utils";
import { CardType } from "../resources/types";

type Props = {
  activityType: string;
};

const CardIcon: FC<Props> = ({ activityType }) => {
  const activityTypes = getAllCardTypeIds();

  const type = (activityType: string) => {
    switch (activityType) {
      case "listen":
        return "sound";
      case "gallery":
        return "carousel";
      default:
        if (activityTypes.includes(activityType as CardType))
          return activityType;
        return "other";
    }
  };

  const Icon = React.lazy(
    () => import(`./../../assets/icons/cards/${type(activityType)}`),
  );

  return (
    <Suspense
      fallback={
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"></svg>
      }
    >
      <Icon title={activityType} />
    </Suspense>
  );
};

export default memo(CardIcon);
